import { createContext, useState } from "react";

export const OnlineStatusContext = createContext();

export const OnlineStatusProvider = ({ children }) => {
  const [onlineStatus, setonlineStatus] = useState([]);

  return (
    <OnlineStatusContext.Provider value={{ onlineStatus, setonlineStatus }}>
      {children}
    </OnlineStatusContext.Provider>
  );
};
